import { CoreApplicationContext } from '@eventbrite/context-gen';
import React from 'react';
import { Agenda, AgendaWidget } from './Agenda';
import { Faq, FaqWidget } from './Faq';

export enum WidgetType {
    Agenda = 'agenda',
    Faqs = 'faqs',
    Faq = 'faq',
}

export interface AppProps {
    widgetType: WidgetType;
    widgetData: AgendaWidget | FaqWidget;
}

export const App: React.FC<AppProps & CoreApplicationContext> = ({
    widgetType,
    widgetData,
}) => {
    return (
        <>
            {widgetType === WidgetType.Agenda && (
                <Agenda agenda={widgetData as AgendaWidget} />
            )}
            {(widgetType === WidgetType.Faq ||
                widgetType === WidgetType.Faqs) && (
                <Faq data={widgetData as FaqWidget} />
            )}
        </>
    );
};
